import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Light mode only. Kept as a context so components that read `darkMode`
// keep working without branching.
export const ThemeProvider = ({ children }) => {
  // clear any leftover dark-mode state from earlier versions
  React.useEffect(() => {
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('darkMode');
  }, []);

  const value = {
    darkMode: false,
    toggleDarkMode: () => {},
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
